import { betPanelHelper } from "app/helpers/betPanelHelper";
import { BetSlipHelper } from "app/helpers/betSlipHelper";
import { BetBuilderEventsType } from "app/types/betBuilderType";
import type { BetSlipType } from "app/types/betSlipType";
import React, { useEffect } from "react";
import { FormattedMessage } from "react-intl";
import { connect } from "react-redux";
import "./BetDrawerSubHeader.scss";

type Props = {
  betSlipList: BetSlipType[];
  betslipFull: boolean;
  purgeBetSlipList: () => void;
  removeAllRunners: () => void;
  collapseAllBetSlips: boolean;
  clearMultiples: () => void;
  removeAllBetBuilders: () => void;
  betBuilderEvents: BetBuilderEventsType[];
  areAllBetSlipsExpanded: boolean;
  toggleExpandCollapseText: () => void;
};

const BetDrawerSubHeader: React.FC<Props> = ({
  betSlipList,
  betslipFull,
  purgeBetSlipList,
  removeAllRunners,
  clearMultiples,
  removeAllBetBuilders,
  betBuilderEvents,
  areAllBetSlipsExpanded,
}) => {
  const removeAllBets = () => {
    purgeBetSlipList();
    // remove all multiples from multiple betslip panel
    clearMultiples();
    // remove all runners from subscription model
    removeAllRunners();
    removeAllBetBuilders();
    BetSlipHelper.clearLocalStorageBetSlipLists();
  };

  const toggleBetslipPanel = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    if (betSlipList.length > 0 || Object.keys(betBuilderEvents).length > 0) {
      betPanelHelper.toggleExpandAllCollapseAllBetSlips();
      betPanelHelper.countExpandedCollapsedBetSlips();
    }
  };

  useEffect(() => {
    betPanelHelper.countExpandedCollapsedBetSlips();
  }, [betSlipList, betBuilderEvents]);

  return (
    <div className="bet-drawer-subheader">
      <div
        className={`bet-drawer-subheader__count ${
          betslipFull ? "bets-full" : ""
        }`}
      >
        {`${betSlipList.length} / 15 `}
        <FormattedMessage tagName="span" id="bets-betslip-bets" />
      </div>
      <button
        className="bet-drawer-subheader__collapse-button"
        onClick={toggleBetslipPanel}
      >
        {areAllBetSlipsExpanded ? (
          <FormattedMessage tagName="span" id="bets-betslip-collapse-all" />
        ) : (
          <FormattedMessage tagName="span" id="bets-betslip-expand-all" />
        )}
      </button>
      <div>
        <button
          className="bet-drawer-subheader__remove-button"
          onClick={removeAllBets}
        >
          <FormattedMessage tagName="span" id="bets-betslip-remove-all" />
        </button>
      </div>
    </div>
  );
};

const mapStateToProps = state => ({
  betSlipList: state.betSlipListModel.betSlipList,
  betslipFull: state.betSlipListModel.betslipFull,
  collapseAllBetSlips: state.betSlipListModel.collapseAllBetSlips,
  betBuilderEvents: state.betBuilderModel.betBuilderEvents,
  areAllBetSlipsExpanded: state.betPanelManagerModel.areAllBetSlipsExpanded,
});

const mapDispatchToProps = dispatch => ({
  purgeBetSlipList: () => dispatch.betSlipListModel.purgeBetSlipList(),
  removeAllRunners: () =>
    dispatch.subscribeModel.removeAllRunnerFromRunnersList(),
  clearMultiples: () => dispatch.multiplesBetSlipListModel.clearMultiples(),
  removeAllBetBuilders: () => dispatch.betBuilderModel.removeAll(),
  toggleExpandCollapseText: () =>
    dispatch.betPanelManagerModel.toggleExpandCollapseText(),
});

export default connect(mapStateToProps, mapDispatchToProps)(BetDrawerSubHeader);
